import { render, staticRenderFns } from "./NewShipmentSelect.vue?vue&type=template&id=557680c2&scoped=true"
import script from "./NewShipmentSelect.vue?vue&type=script&lang=js"
export * from "./NewShipmentSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557680c2",
  null
  
)

export default component.exports